export const firebaseConfig = {
  apiKey: 'AIzaSyAS7K9zXVHGPjjGa2KQa4BPFpjWrNdrHL8',
  authDomain: 'devfest-triangle.firebaseapp.com',
  databaseURL: 'https://devfest-triangle.firebaseio.com',
  projectId: 'devfest-triangle',
  storageBucket: 'devfest-triangle.appspot.com',
  messagingSenderId: '883917746859',
  // Firebase node which your data will be stored (ex. 2017)
  devfestYear: '2019',
  // Your Google Maps API key
  mapsKey: 'AIzaSyC-gKA70rg7KvOAIN5GVT5xykNbKfeLo-k'
}
